import Vue from 'vue';

const WindowStore = {
    width: null,
    height: null,
    deviceType: null,
    currentDeviceClass: null,
    bodyClasses: document.body.classList,
    getWindowWidth() {
        return window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
    },
    getWindowHeight() {
        return window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
    },
    getDeviceType() {
        if (this.width >= 768 && this.width <= 992) {
            return 'tablet';
        }
        if (this.width < 768) {
            return 'phone';
        }
        return 'desktop';
    },
    deviceClass() {
        return 'device-' + this.deviceType;
    },
    updateWindowSizes() {
        this.width = this.getWindowWidth();
        this.height = this.getWindowHeight();
        this.deviceType = this.getDeviceType();
        if (this.currentDeviceClass !== null) {
            this.bodyClasses.remove(this.currentDeviceClass);
        }
        this.currentDeviceClass = this.deviceClass();
        this.bodyClasses.add(this.currentDeviceClass);
        return this;
    },
};


const MilestonesPlugin = {

    install(Vue, options) {
        //Body Classes
        Vue.prototype.$bodyClasses = WindowStore.bodyClasses;

        //UI global
        Vue.prototype.$window = WindowStore.updateWindowSizes();

    },
};

export default MilestonesPlugin;
